/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portfolio_Project_4_ResultInputs */

const et_portfolio_project_4_result = /** @type {(inputs: Portfolio_Project_4_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutasime Google top 1 positsiooni 60 päevaga, kohalikud päringud kasvasid märkimisväärselt.`)
};

const en_portfolio_project_4_result = /** @type {(inputs: Portfolio_Project_4_ResultInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reached top 1 Google rankings in 60 days, driving a significant increase in local inquiries.`)
};

/**
* | output |
* | --- |
* | "Reached top 1 Google rankings in 60 days, driving a significant increase in local inquiries." |
*
* @param {Portfolio_Project_4_ResultInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const portfolio_project_4_result = /** @type {((inputs?: Portfolio_Project_4_ResultInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portfolio_Project_4_ResultInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_portfolio_project_4_result(inputs)
	return en_portfolio_project_4_result(inputs)
});